export default __webpack_public_path__ + "static/media/breakfast.d19b6736.png";